export const useSxStyles = () => {
  return {
    table: {
      borderCollapse: 'collapse',
      cellSpacing: '0px',
      '& thead': {
        '& th': {
          padding: 0,
          textAlign: 'left',
          fontSize: '13px',
          fontWeight: 'bold',
        },
      },
      '& tbody': {
        '& td': {
          textAlign: 'left',
          fontSize: '13px',
          padding: '0px',
        },
      },
    },
    thDegree: {
      width: '250px',
      minWidth: '250px',
      textAlign: 'left',
      fontSize: '13px',
      fontWeight: 'bold',
    },
    thInsti: {
      width: '250px',
      minWidth: '250px',
      textAlign: 'left',
      fontSize: '13px',
      fontWeight: 'bold',
    },
    thSubject: {
      width: '450px',
      minWidth: '450px',
      textAlign: 'left',
      fontSize: '13px',
      fontWeight: 'bold',
    },
    thEndDate: {
      width: '170px',
      minWidth: '170px',
      textAlign: 'left',
      fontSize: '13px',
      fontWeight: 'bold',
    },
    td: {
      textAlign: 'left',
      fontSize: '13px',
    },
  };
};
